<div
  class="line-item-delta-alert"
  *ngIf="!!data"
  [ngClass]="{ disabled: !data.subscribed }"
>
  <div class="lid-section subscription-section" *ngIf="showSubscription">
    <div>Subscription</div>
    <div>
      <nz-switch
        [ngModel]="data.subscribed"
        nzSize="small"
        (ngModelChange)="onSubscriptionChange($event)"
        [nzCheckedChildren]="checkedTemplate"
        [nzUnCheckedChildren]="unCheckedTemplate"
      ></nz-switch>
    </div>
  </div>
  <div class="main-header">
    <div class="header">
      Receive alerts when consensus of any line item in my monitor...
    </div>
  </div>

  <div class="lid-section">
    <div class="header">Is revised by over:</div>
    <div>
      <nz-radio-group
        [(ngModel)]="percentageValue"
        (ngModelChange)="onPercentageChange($event)"
        [nzDisabled]="!data.subscribed"
      >
        <ng-container *ngFor="let option of percentageOptions">
          <label nz-radio [nzValue]="option.value">
            <span class="plus-minus-icon">
              <!-- <va-icon
                class="alert-icon"
                size="small"
                name="plus"
                transform="shrink-5 up-6"
              ></va-icon>
              <va-icon
                class="alert-icon"  size="small"
                name="minus"
                transform="shrink-5 down-2"
              ></va-icon> -->
              <span>+</span>
              <span style="position: relative; right: 6.5px;">_</span>
            </span>
            <span>{{ option.label }}%</span></label
          >
        </ng-container>
      </nz-radio-group>
    </div>
  </div>

  <div class="lid-section">
    <div class="header">In the last:</div>
    <div>
      <nz-radio-group
        [(ngModel)]="baselineValue"
        (ngModelChange)="onBaselineChange($event)"
        [nzDisabled]="!data.subscribed"
      >
        <ng-container *ngFor="let option of baselineOptions">
          <label nz-radio [nzValue]="option.value"
            >{{ option.label }} days</label
          >
        </ng-container>
      </nz-radio-group>
    </div>
  </div>

  <div class="lid-section">
    <div class="header">For periods in my monitor:</div>
    <div
      class="checkbox-wrapper"
      nz-tooltip
      nzTooltipTitle="Please select atleast one period."
    >
      <nz-checkbox-group
        [(ngModel)]="periodValues"
        (ngModelChange)="onPeriodChange($event)"
        [nzDisabled]="!data.subscribed"
      ></nz-checkbox-group>
    </div>
  </div>
</div>

<div *ngIf="!data" class="error">
  <va-icon name="exclamation-triangle"  size="small" class="info-icon"></va-icon>
  <span class="error-text">Sorry, something went wrong.</span>
</div>
<ng-template #checkedTemplate>
  <va-icon size="small" name="check"></va-icon>
</ng-template>
<ng-template #unCheckedTemplate>
  <va-icon size="small" name="close"></va-icon>
</ng-template>
